export default {
  inject: ["$item"],
  computed: {
    item() {
      return this.$item();
    },
    width() {
      if (this.item) {
        return this.item.widthPx;
      }
      return 0;
    },
    height() {
      if (this.item) {
        return this.item.heightPx;
      }
      return 0;
    },
    moving() {
      if (this.item) {
        return this.item.moving;
      }
      return 0;
    },
    resizing() {
      if (this.item) {
        return this.item.resizing;
      }
      return 0;
    },
  },
};
